/**
 * This function returns a functional component that will be used to render each dot in a recharts chart
 * @param color Color to use for our dot
 */
const LineDotWithNullZero = (color: string, textColor: string) => {
  return ({ cx, cy, payload, value }) => {
    return value > 0 ? (
      <g x={cx} y={cy}>
        <circle cx={cx} cy={cy} r={8} fill={color} />
        <text x={cx} y={cy - 8} textAnchor="middle" stroke={textColor}>
          {value}
        </text>
      </g>
    ) : null;
  };
};

export default LineDotWithNullZero;
